import Mutations from '../../odata/mutations';

export default { ...new Mutations('masterProduct'), ...new Mutations('masterProducts') };
